import { SignupCard } from '../SignupCard'

const HOW_IT_WORKS_COPY = [
  'Drive Uber when you want, and maintain an 80% acceptance rate for ride requests.',
  'Every Sunday, we check to see if you earned less than your guaranteed income during the hours you drove.',
  'If you earn under, we pay you the difference. If you earn over, we charge up to a small 4% service fee.',
]

type HowItWorksProps = {
  children?: React.ReactNode
}

export const HowItWorks = ({ children }: HowItWorksProps): JSX.Element => {
  return (
    <SignupCard heading='How It Works'>
      <div className='flex flex-col gap-5'>
        {HOW_IT_WORKS_COPY.map((copyStr, i) => (
          <div key={i} className='flex gap-4'>
            <div className='flex-none bg-brand-light-purple rounded-full h-16 w-16 flex justify-center items-center'>
              <p className='text-2xl text-white font-semibold'>{i + 1}</p>
            </div>
            <p className='text-sm leading-6 font-extralight text-body-black pt-1'>
              {copyStr}
            </p>
          </div>
        ))}
        <div className='mt-6 flex flex-col gap-4 items-center'>{children}</div>
      </div>
    </SignupCard>
  )
}
